module.exports = "/static/assets/50d1e5652da2e04f6d6f10fd32832356.png";